var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4813 0.292893C14.8718 0.683417 14.8718 1.31658 14.4813 1.70711L8.8013 7.38711L14.4813 13.0671C14.8718 13.4576 14.8718 14.0908 14.4813 14.4813C14.0908 14.8719 13.4576 14.8719 13.0671 14.4813L7.38709 8.80132L1.70711 14.4813C1.31658 14.8718 0.683417 14.8718 0.292893 14.4813C-0.0976311 14.0908 -0.0976311 13.4576 0.292893 13.0671L5.97287 7.38711L0.292893 1.70713C-0.0976311 1.31661 -0.0976311 0.683442 0.292893 0.292918C0.683417 -0.0976067 1.31658 -0.0976067 1.70711 0.292918L7.38709 5.9729L13.0671 0.292893C13.4576 -0.0976311 14.0908 -0.0976311 14.4813 0.292893Z",
    fill: "#CA2867"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.4013d24679375e988a10db8b9cfb4bd2.svg";
export { ForwardRef as ReactComponent };